var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"min-w-60px",attrs:{"variant":_vm.variant},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.loading)?_c('span',{staticClass:"loading-spinner ml-1"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }